import { action } from 'mobx';
import stores from 'cd-eft/models/Stores';

const libraryStore = stores.AppStore.projectsLibraryStore;

export class FilterVM {
  props;
  constructor(props) {
    this.props = props;
  }

  @action.bound onClickAdvansedSearch(e) {
    e.preventDefault();
    libraryStore.advancedSearchIsOpen = !libraryStore.advancedSearchIsOpen;
  }

  @action.bound onSubmitForm(e) {
    e.preventDefault();
    filterProjects();
  }

  @action.bound setLimitPerPage(e) {
    libraryStore.limitPerPage = e.target.value;
  }
}

export const setSortByValue = (e) => {
  libraryStore.sortBy = e.target.value;

  setSortByValueActon();
};

export const setSortByValueActon = () => {
  let sortByProjects = [...libraryStore.filteredProjects];

  if (Number(libraryStore.sortBy) === 1) {
    const sortedByProjectName = sortByProjects.sort((a, b) => {
      const fa = a.projectTitle.toLowerCase();
      const fb = b.projectTitle.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    sortByProjects = sortedByProjectName;
  }

  if (Number(libraryStore.sortBy) === 2) {
    const sortedByDateAsc = sortByProjects.sort((a, b) => {
      return Date.parse(a.lastChangedDate) - Date.parse(b.lastChangedDate);
    });
    sortByProjects = sortedByDateAsc;
  }

  if (Number(libraryStore.sortBy) === 3) {
    const sortedByDateDesc = sortByProjects.sort((a, b) => {
      return Date.parse(b.lastChangedDate) - Date.parse(a.lastChangedDate);
    });
    sortByProjects = sortedByDateDesc;
  }

  libraryStore.filteredProjects = sortByProjects;
};

export const filterProjects = () => {
  let filteredProjects = libraryStore.projects;

  if (String(libraryStore.filterString) !== '') {
    const string = libraryStore.filterString.toLowerCase();
    const filteredByString = filteredProjects.filter(
      (project) =>
        project.createdBy.toLowerCase().includes(string) || project.projectTitle.toLowerCase().includes(string)
    );
    filteredProjects = filteredByString;
  }

  const filteredByType = filteredProjects.filter((project) =>
    libraryStore.filterProjectTypes.has(Number(project.projectClassId))
  );
  filteredProjects = filteredByType;

  const filteredByStatus = filteredProjects.filter(
    (project) =>
      libraryStore.filterProjectTypes.has(Number(project.projectClassId)) &&
      libraryStore.filterProjectStatuses.has(Number(project.projectStatusId))
  );
  filteredProjects = filteredByStatus;

  libraryStore.filteredProjects = filteredProjects;
};

export const setFilterValue = (e) => {
  libraryStore.filterString = e.target.value;
};
